<template>    
    <v-card>
        <!-- Titulo del dialogo -->
        <v-card-title>
            Crear Procedencia
        </v-card-title>
        <v-divider></v-divider>
            <!-- Formulario -->
        <v-form ref="form">
            <v-row class="py-3 px-6">
                <v-col cols="12" sm="6" md="3">
                    <v-text-field :rules="[v => !!v || 'Campo requerido']" v-model="editedItem.nombre" label="Nombre"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-text-field :rules="[v => !!v || 'Campo requerido']" v-model="editedItem.valor" type="number" label="Costo de Envio"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-text-field :rules="[v => !!v || 'Campo requerido']" v-model="editedItem.tiempo_de_entrega" type="number" label="Tiempo de Entrega"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-select :rules="[v => !!v || 'Campo requerido']" v-model="editedItem.sucursal" :items="sucursales" item-text="nombre" item-value="id" label="Sucursal"></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <v-card-actions class="pt-4">
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text :disabled="!valid" @click="save">Guardar</v-btn>
                    </v-card-actions>
                </v-col>
            </v-row>
        </v-form>
    </v-card>
</template>
<script>
import axios from "axios";
export default {
    data:()=>({  
        valid: true,
        editedItem: {
            nombre:'',
            valor:'',
            tiempo_de_entrega:'',
            sucursal:'',
        },
        rules: {
            required: value => !!value || 'Campo requerido',
        },
    }),
    methods:{
        close () {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.$nextTick(() => {
                this.$emit("closeCreateDialogColonia", false);
            })
        },
        save () {
            axios.post("https://torstdio.site/api/v1/colonia/guardar",Object.assign(this.editedItem)).then(response=>{
                this.close()
            })
        },
    },
    computed:{
        sucursales(){
            return this.$store.state.sucursal.sucursales
        }
    },
    created(){
        this.$store.dispatch('sucursal/getSucursales')
    }
}
</script>